// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portscan-container {
  max-width: 600px;
  margin: 30px auto;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.portscan-title {
  font-size: 1.5rem;
  margin-bottom: 20px;
  text-align: center;
  color: #2c3e50;
}

.portscan-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
}

.portscan-button {
  padding: 10px;
  background-color: #3498db;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.portscan-button:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.portscan-button:hover:enabled {
  background-color: #2980b9;
}

.portscan-results {
  margin-top: 20px;
}

.portscan-table {
  width: 100%;
  border-collapse: collapse;
}

.portscan-table th,
.portscan-table td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.status-open td {
  background-color: #e0f8e0;
  color: green;
}

.status-closed td {
  background-color: #f8e0e0;
  color: red;
}

.status-error td {
  background-color: #fff4e5;
  color: orange;
}
`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/PortScanner.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf","sourcesContent":[".portscan-container {\n  max-width: 600px;\n  margin: 30px auto;\n  padding: 20px;\n  background-color: #f5f7fa;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.portscan-title {\n  font-size: 1.5rem;\n  margin-bottom: 20px;\n  text-align: center;\n  color: #2c3e50;\n}\n\n.portscan-input {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 1rem;\n}\n\n.portscan-button {\n  padding: 10px;\n  background-color: #3498db;\n  color: white;\n  font-weight: bold;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.portscan-button:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.portscan-button:hover:enabled {\n  background-color: #2980b9;\n}\n\n.portscan-results {\n  margin-top: 20px;\n}\n\n.portscan-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.portscan-table th,\n.portscan-table td {\n  padding: 10px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.status-open td {\n  background-color: #e0f8e0;\n  color: green;\n}\n\n.status-closed td {\n  background-color: #f8e0e0;\n  color: red;\n}\n\n.status-error td {\n  background-color: #fff4e5;\n  color: orange;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
